export const MonacoEditorConfig = {
  sizeSettings: {
    width: '300px'
  }
};
